/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.donations.amount.list.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.permissions',
  'acme.common.factory.notice',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.common.service.userPreferences',
  'acme.common.service.templates',
  'acme.view.application.donations.amount.createModal.controllers',
  'acme.view.application.donations.amount.removeModal.controllers'
])

.controller('DonationsAmountListController', [
  '$scope', '$state', '$filter', '$timeout', '$uibModal', '$q', 'ApiService', 'PermissionsService', 'TemplatesService', 'HelpersService', 'NoticeFactory', 'GridStateFactory', 'GridDefinitionFactory',
  function($scope, $state, $filter, $timeout, $uibModal, $q, ApiService, PermissionsService, TemplatesService, HelpersService, NoticeFactory, GridStateFactory, GridDefinitionFactory) {

    $scope.donationsAmountList = {

      model: [],

      searchQuery: '',
      searchTimer: false,

      viewId: '',
      donationsAmountGridName: $state.current.name+'.grid0',
      modal: {},

      notice: new NoticeFactory(),
      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),

      optionsOverride: {
        useAccessibleGrid: true,
        data: 'donationsAmountList.model',
        columnDefs: [
          {
            field: 'id',
            visible: false
          },
          {
            field: 'order',
            visible: false
          },
          {
            field: 'name',
            displayName: 'Name',
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html'
          },
          {
            field: 'description',
            displayName: 'Description',
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html'
          },
          {
            field: 'sku',
            displayName: 'SKU',
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html'
          },
          {
            field: 'type',
            displayName: 'Type',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.type | typeToLabel }}</div>'
          },
          {
            field: 'printTicket',
            displayName: 'Print Ticket',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ (row.entity.printTicket) ? "Yes" : "No" }}</div>'
          },
          {
            field: 'price',
            displayName: 'Price',
            cellFilter: 'currency',
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html'
          },
          {
            field: 'salesChannels[0].enabled',
            displayName: 'Web',
            cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>',
            cellRenderer: function(param) {
              var r = '';
              if ((param.node.data.salesChannels instanceof Array) && param.node.data.salesChannels[0].enabled) {
                r = 'Yes';
              } else {
                r = 'No';
              }
              return r;
            }
          },
          {
            field: 'salesChannels[1].enabled',
            displayName: 'POS',
            cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>',
            cellRenderer: function(param) {
              var r = '';
              if ((param.node.data.salesChannels instanceof Array) && param.node.data.salesChannels[1].enabled) {
                r = 'Yes';
              } else {
                r = 'No';
              }
              return r;
            }
          },
          {
            field: 'salesChannels[2].enabled',
            displayName: 'Reseller',
            cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-class="{ inactive: grid.appScope.programsDetailOverview.restrictMembers }" data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>',
            cellRenderer: function(param) {
              var r = '';
              if ((param.node.data.salesChannels instanceof Array) && param.node.data.salesChannels[2].enabled) {
                r = 'Yes';
              } else {
                r = 'No';
              }
              return r;
            }
          },
          {
            field: 'salesChannels[3].enabled',
            displayName: 'Customer Rep.',
            cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>',
            cellRenderer: function(param) {
              var r = '';
              if ((param.node.data.salesChannels instanceof Array) && param.node.data.salesChannels[3].enabled) {
                r = 'Yes';
              } else {
                r = 'No';
              }
              return r;
            }
          }
        ],
        appScopeProvider: {
          onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.donationsAmountList.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDataGridSortChange: function(grid, columns, page) {
            $scope.donationsAmountList.onDataGridSortChange(grid, columns, page);
          },
          onDblClick: function (item) {
            $scope.donationsAmountList.onDblClick(item);
          },
          edit: function (id) {
            $scope.donationsAmountList.edit(id);
          },
          remove: function(id) {
            $scope.donationsAmountList.remove(id);
          }
        }
      },

      init: function() {

        $scope.$emit('Application::contentTitleChange', {
          title: 'Amount',
          buttonRight: {
            permissions: 'ADDONS_CREATE',
            label: 'New Amount',
            action: function() {
              $scope.donationsAmountList.create();
            }
          }
        });

        if (PermissionsService.check('ADDONS_DELETE')) {
          this.optionsOverride.columnDefs.push({
            field: 'remove',
            displayName: 'Remove',
            width: 80,
            onCellNavClick: function(row, col) {
              $scope.donationsAmountList.optionsOverride.appScopeProvider.remove(row.entity.id);
            },
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.remove(row.entity.id)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>'
          });
        }

        if (PermissionsService.check('ADDONS_UPDATE')) {
          this.optionsOverride.columnDefs.unshift({
            field: 'editable',
            displayName: 'Edit',
            width: 60,
            onCellNavClick: function(row, col) {
              $scope.donationsAmountList.optionsOverride.appScopeProvider.edit(row.entity.id);
            },
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.edit(row.entity.id)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>'
          });
        }


        this.viewId = $state.current.name;
        this.gridDefinition.init(this.donationsAmountGridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);

        $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', this.initData));
        $scope.$on('$destroy', $scope.$watch('donationsAmountList.searchQuery', this.onSearchQueryUpdate));
      },

      initData: function(e, data) {
        var self = $scope.donationsAmountList, props = self.gridDefinition.getGridState();
        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.getAmountList();
      },

      getAmountList: function() {
        self = $scope.donationsAmountList;
        ApiService.inventory.list(angular.extend({ addonTypes: 'donation,fixedDonation' }, self.gridState.getGridState())).then(self.success.getAmountList, self.error.getAmountList);
      },

      create: function () {
        var self = $scope.donationsAmountList;

        self.modal = $uibModal.open({
          templateUrl: 'views/application/views/donations/amount/list/modals/createAmount.tpl.html',
          size: 'lg',
          controller: 'DonationsAmountCreateModalController',
          resolve: {
            inventory: function() {
              return self.model;
            },
            currentInventory: function() {
              return false;
            },
            hasDonation: function() {
              var q = $q.defer();

              ApiService.inventory.list(angular.extend(angular.copy(self.gridState.getGridState()), { addonTypes: 'donation' })).then(function(response) {
                q.resolve(response.data.payload.list);
              }, function(response) {
                q.resolve(false);
              });

              return q.promise;
            }
          }
        });

        self.modal.result.then(function (amount) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();
          ApiService.inventory.create(amount).then(self.success.create, self.error.create);
        }, function () {
          // Do nothing
        });
      },

      edit: function(id) {
        var self = $scope.donationsAmountList,
            found = self.findInventory(id);

        self.modal = $uibModal.open({
          templateUrl: 'views/application/views/donations/amount/list/modals/createAmount.tpl.html',
          size: 'lg',
          controller: 'DonationsAmountCreateModalController',
          resolve: {
            inventory: function() {
              return self.model;
            },
            currentInventory: function() {
              return (found) ? found.item : false;
            },
            hasDonation: function() {
              var q = $q.defer();

              ApiService.inventory.list(angular.extend(angular.copy(self.gridState.getGridState()), { addonTypes: 'donation' })).then(function(response) {
                q.resolve(response.data.payload.list);
              }, function(response) {
                q.resolve(false);
              });

              return q.promise;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.modal.result.then(function (amount) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();
          ApiService.inventory.update(amount).then(self.success.update, self.error.update);
        }, function () {
          // Do nothing
        });
      },

      remove: function(id) {
        var self = $scope.donationsAmountList;

        self.modal = $uibModal.open({
          templateUrl: 'views/application/views/donations/amount/list/modals/removeAmount.tpl.html',
          size: 'md',
          controller: 'DonationsAmountRemoveModalController',
          resolve: {
            currentInventory: function() {
              return self.findInventory(id).item;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.modal.result.then(function (amount) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();
          ApiService.inventory.remove(id).then(self.success.remove, self.error.remove);
        }, function () {
          // Do nothing
        });
      },

      findInventory: function(id) {
        var i, ii,
            r = false;

        for (i=0,ii=this.model.length;i<ii;i++) {
          if (parseInt(this.model[i].id, 10) === parseInt(id, 10)) {
            r = {
              index: i,
              item: this.model[i]
            };
            break;
          }
        }

        return r;
      },

      processSalesChannels: function(list) {
        var i, ii;
        for (i=0,ii=list.length;i<ii;i++) {
          list[i].salesChannels = TemplatesService.orderSalesChannels(list[i].salesChannels);
        }
        return list;
      },

      success: {
        init: function(response) {},
        getAmountList: function (response) {
          var self = $scope.donationsAmountList;
          self.model = self.processSalesChannels(response.data.payload.list);
          self.gridDefinition.isLoaded = true;
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.length, totalItems: response.data.payload.pagination.count});
          }, 10);
        },
        create: function(response) {
          var self = $scope.donationsAmountList;
          self.gridState.setPropertyValue('search', '');
          self.getAmountList();
        },
        update: function(response) {
          var self = $scope.donationsAmountList;
          self.gridState.setPropertyValue('search', self.searchQuery);
          self.getAmountList();
        },
        remove: function(){
          var self = $scope.donationsAmountList;
          self.gridState.setPropertyValue('search', self.searchQuery);
          self.getAmountList();
        }
      },

      error: {
        init: function(response) {},
        getInventoryList: function () {},
        create: function() {},
        update: function() {},
        remove: function() {}
      },

      onSearchQueryUpdate: function(n, o) {
        var self = $scope.donationsAmountList;
        self.gridState.setPropertyValue('search', self.searchQuery);
        $scope.$broadcast('DataGrid::Search', {name: self.donationsAmountGridName});
      },

      onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
        var self = $scope.donationsAmountList;
        self.gridState.updateGridState(newPage, pageSize);
        if (sortField) {
          self.gridState.updateGridState(null, null, sortField, null);
        }
        if(sortDirection) {
          self.gridState.updateGridState(null, null, null, sortDirection);
        }
        self.getAmountList();
      },

      onDataGridSortChange: function(grid, columns, page) {
        var self = $scope.donationsAmountList, data = columns[0];
        self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
        self.getAmountList();
      },

      onDblClick: function(item) {
        var self = $scope.donationsAmountList;
        $scope.donationsAmountList.edit(item.entity.id);
      }
    };

    $scope.donationsAmountList.init();

}]);
